import React from 'react';
import { personalizedOnboarding } from '@/services/survey.service';
import { Mixpanel } from '@/utils/mixpanel';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import RightArrow from '@/components/Icons/icons/RightArrow';

interface SurveyFinalScreenV2Interface {
  onClose: () => {};
}

const SurveyFinalScreenV2 = ({ onClose }: SurveyFinalScreenV2Interface) => {
  const { userDetails } = useSelector((state: any) => state.user);
  const title = 'Did you book your meeting with customer happiness?';
  const description = (
    <div>
      The platform is great, but having a real human to chat with is better.
      <br />
      <br />
      To help you achieve your objectives and set you up for success, we recommend booking a meeting with our happiness
      team. <br />
      <br />
      Attending the first meeting with CS not only helps you with onboarding, it also gives you a chance to qualify for
      an extended trial access!
    </div>
  );

  const primaryButtonText = 'Schedule a meeting';
  const secondaryButtonText = "I've already booked";
  const navigate = useNavigate();

  const handlePrimaryButtonClick = async () => {
    Mixpanel.identify(userDetails?._id);
    Mixpanel.people.set({ 'Strategy Session Requested': true });
    Mixpanel.track('onboarding_step_completed', {
      'Step Name': 'Final Step',
      'Step Number': 3,
      Responses: { personalisedOnboarding: true },
    });

    await personalizedOnboarding({ personalisedOnboarding: true });
    navigate('/book-session?next=onboarding');
    //@ts-ignore
    onClose(false);
  };

  const handleSecondaryButtonClick = async () => {
    Mixpanel.people.set({ 'Strategy Session Requested': false });
    Mixpanel.track('onboarding_step_completed', {
      'Step Name': 'Final Step',
      'Step Number': 4,
      Responses: { personalisedOnboarding: false },
    });
    await personalizedOnboarding({ personalisedOnboarding: false });
    //@ts-ignore
    onClose(false);
  };

  return (
    <div className="survey-final-container-v2">
      <div className="survey-final-content">
        <div className="survey-final-left">
          <div className="survey-final-text">
            <div className="title">{title}</div>
            <div className="description">{description}</div>
          </div>
          <div className="survey-final-bottom-container">
            <ButtonComponent onClick={handleSecondaryButtonClick} style={{ flex: 1 }} variant="secondary">
              {secondaryButtonText}
            </ButtonComponent>
            <ButtonComponent style={{ flex: 1 }} onClick={handlePrimaryButtonClick}>
              {primaryButtonText} <RightArrow width={18} height={22} color="#fff" />
            </ButtonComponent>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyFinalScreenV2;
